/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Green_Elk_GazeInputs */

const en_soft_green_elk_gaze = /** @type {(inputs: Soft_Green_Elk_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override the default minimum answers for this segment`)
};

const de_soft_green_elk_gaze = /** @type {(inputs: Soft_Green_Elk_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Mindestantworten für dieses Segment überschreiben`)
};

/**
* | output |
* | --- |
* | "Override the default minimum answers for this segment" |
*
* @param {Soft_Green_Elk_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_green_elk_gaze = /** @type {((inputs?: Soft_Green_Elk_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Green_Elk_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_green_elk_gaze(inputs)
	return de_soft_green_elk_gaze(inputs)
});